import React, { Component } from "react";
import _ from "lodash";
import {formatMoney} from "accounting-js";

class ActivityWidget extends Component {
	render() {
		let {disabled, activities} = this.props;
		return <div>
			<label htmlFor="activityAdd" className="label">Seleccionar actividades</label>
			<div className="field has-addons">
				<div className="control is-expanded">
					<div className="select is-fullwidth">
						<select ref="activitySelect" disabled={disabled} id="activityAdd" onChange={() => this._activityValue()}>
							<option value={0} defaultValue>--- Actividades ---</option>
							{(!_.isEmpty(activities) && !_.isEmpty(activities.activities)) && _.map(activities.activities, (item, j) => {
								return <option value={item.id} key={j}>{item.name}</option>
							})}
						</select>
					</div>
				</div>
				<div className="control">
					<input type="number" ref="quantity" id="quantity" placeholder="Cantidad" className="input" min="1" step="1" defaultValue={1} onChange={() => this._activityValue()} disabled={disabled} />
				</div>
				<div className="control">
					<input type="text" ref="total" id="total" placeholder="0.00" className="input" readOnly disabled={disabled} />
				</div>
				<div className="control">
					<button type="button" className="button is-info" onClick={() => this._addActivity()} disabled={disabled}>Agregar</button>
				</div>
			</div>
		</div>
	}

	_addActivity() {
		let { goal, goals, activities } = this.props;
		let selected = _.findKey(goals, {proigualdad_goal_id: goal.proigualdad_goal_id});
		let activity = _.find(activities.activities, {id: _.toInteger(this.refs.activitySelect.value)});
		let hasIt = _.find(goal.project_goal_activities, {proigualdad_activity_id: activity.id});
		let activitySize = _.size(goal.proigualdad_goal_id);
		if(hasIt === undefined && activitySize <= 4){
			this.props.add(`project.registry.data.project_goals[${selected}].project_goal_activities`, {
				id: activity.id,
				proigualdad_activity_id: activity.id,
				name: activity.name,
				quantity: _.toInteger(this.refs.quantity.value),
				amount: activity.amount,
				total: _.toInteger(this.refs.quantity.value) * activity.amount,
				mandatory: activity.mandatory,
				verification_media: activity.verification_media[0]
			});
			let newTotal = (_.toNumber(goal.total) + (_.toInteger(this.refs.quantity.value) * activity.amount));
			this.props.change(`project.registry.project_goals[${goal.proigualdad_goal_id}].total`, newTotal);
			this.refs.activitySelect.value = 0;
			this.refs.quantity.value = 1;
			this.refs.total.value = '';
		}else if(activitySize >= 5) {
			alert('Cada meta puede tener un máximo de 5 actividades');
		}else{
			alert('No se pueden duplicar actividades');
		}
	}

	_activityValue() {
		let { activities } = this.props;
		let activity = _.find(activities.activities, {id: _.toInteger(this.refs.activitySelect.value)});
		if(activity) {
			this.refs.total.value = formatMoney(_.toNumber(this.refs.quantity.value * activity.amount));
		}
	}
}

export default ActivityWidget;


// WEBPACK FOOTER //
// ./src/elements/project/widgets/activities.jsx